import React from "react";
import { Menu, Avatar, Dropdown, Modal } from "antd";
import { t } from "i18next";

import { getUserInfo } from "common";
import styles from "./index.module.less";

import {
  UserOutlined,
  LogoutOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import axios from "common/axios";

export default function (props) {
  // 退出登录
  const userinfo = getUserInfo();
  const { customerCode, name } = userinfo;
  const out = () => {
    Modal.confirm({
      title: t("Tip"),
      icon: <ExclamationCircleOutlined />,
      content: t("toLogOut"),
      onOk() {
        axios.post("/quit/logout");
        // 不管接口返回如何，都应该跳转到登录页, 此处设置延迟，以免过早清除token导致接口无法拿到token, 在登录页加载时清除用户信息
        setTimeout(() => {
          window.localStorage.removeItem('authorization')
          window.localStorage.removeItem('useInfo')
          props.history.push("/login");
        }, 0);
      },
    });
  };

  function welcomeTxt() {
    const now = new Date(),
      hour = now.getHours();
    let text = "";
    if (hour < 6) {
      text = "真早呀";
    } else if (hour < 9) {
      text = "早上好";
    } else if (hour < 12) {
      text = "上午好";
    } else if (hour < 14) {
      text = "中午好";
    } else if (hour < 17) {
      text = "下午好";
    } else if (hour < 19) {
      text = "傍晚好";
    } else if (hour < 21) {
      text = "晚上好";
    } else {
      text = "夜深了";
    }
    return text;
  }

  return (
    <div className={styles.userInfo}>
      <span className={styles.code}>Code: {customerCode}</span>
      <Dropdown
        overlay={
          <Menu onClick={out}>
            <Menu.Item key="loginout">
              <LogoutOutlined />
              {t("Logout")}
            </Menu.Item>
          </Menu>
        }
      >
        <div>
          <Avatar icon={<UserOutlined />} />
          <p className={styles.userName}>
            <span>
              {name || "lili"}
            </span>
            <br />
            {/* <small>{username}</small> */}
          </p>
        </div>
      </Dropdown>
    </div> 
  );
}
